<template>
  <form @submit.prevent="handleSubmit" class="flex flex-col gap-y-4">
    <div class="text-5xl font-medium">
      {{ __('Create Job Template') }}
    </div>

    <JobForm :data="data" :errors="errors" :is-job-template="true" />

    <TemplateSubmitSection
      :action-text="__('Create Template')"
      :isLoading="isLoading"
      :metadata="data.metadata"
      @update:status="data.metadata.status = $event"
      @updateAction="action = $event"
    />

    <TemplatesOverwriteModal
      v-if="isOverWriteTemplateModalOpen"
      :is-loading="isLoadingOverwriteTemplate"
      @overwrite="handleOverwriteTemplate"
      @cancel="isOverWriteTemplateModalOpen = false"
    />
  </form>
</template>
<script setup>
  import {reactive, ref} from 'vue';
  import JobForm from '../partials/JobForm.vue';
  import TemplateSubmitSection from './components/TemplateSubmitSection.vue';
  import { useToast } from 'vue-toastification';
  import TemplatesOverwriteModal from './components/TemplatesOverwriteModal.vue';
  import { __ } from '@/helpers';

  const toast = useToast();
  const props = defineProps({
    data: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true,
      default: () => ({})
    }
  });

  const isLoading = ref(false);
  const data = reactive(props.data);
        data.override = false;
  const isLoadingOverwriteTemplate = ref(false);
  const isOverWriteTemplateModalOpen = ref(false);


  const submitTemplate = async () => {
    return await axios.post(
        route('redesign.company.templates.save'),
        data
    );
  };

  const handleSubmit = async () => {
    isLoading.value = true;
    data.override = false;
    try {
      const response = await submitTemplate();
      redirectAfterSuccess(response);
    } catch (error) {
      if (error.response?.status === 409) {
        isOverWriteTemplateModalOpen.value = true;
      } else {
        toast.error(error.response?.data?.message || __('An unexpected error occurred. Please try again later.'));
      }
    } finally {
      isLoading.value = false;
    }
  };


  const handleOverwriteTemplate = async () => {
    isLoadingOverwriteTemplate.value = true;
    data.override = true;
    try {
      const response = await submitTemplate();
      redirectAfterSuccess(response);
    } catch (error) {
      toast.error(error.response?.data?.message || __('Something went wrong.'));
    } finally {
      isLoadingOverwriteTemplate.value = false;
      isOverWriteTemplateModalOpen.value = false;
    }
  };

  const redirectAfterSuccess = (response) => {
    toast.success(response.data?.message);
    setTimeout(() => {
      window.location.href = route('redesign.company.templates.index');
    }, 1200);
  };
</script>
